import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import Tooltip from '../tooltip/tooltip'
import IconStatusIcon from './icon-status-icon'

import styles from './icon-status-wrapper.module.css'

const propTypes = {
    iconClassName: PropTypes.string,
    status: PropTypes.string,
    statusIconWidth: PropTypes.number,
    toolTipText: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
}

const defaultProps = {
    iconClassName: '',
    statusIconWidth: 16
}

/**
 * Render status icon.
 *
 * @param {Object} props - The property object.
 * @param {string} [props.status] - The given status.
 * @param {string} [props.statusIconWidth=16] - The width for the status icon.
 * @param {string} [props.toolTipText] - Tooltip text.
 */
function renderStatusIcon(params) {
    const { iconClassName, status, statusIconWidth, toolTipText } = params

    if (!status) {
        return null
    }
    const statusIconProps = {
        className: cx(styles['status-icon'], iconClassName),
        status,
        width: statusIconWidth
    }

    return toolTipText ? (
        <Tooltip content={toolTipText} placement="right">
            <div className="t3sel-status-icon-tooltip">
                <IconStatusIcon {...statusIconProps} />
            </div>
        </Tooltip>
    ) : (
        <IconStatusIcon data-testid="icon-status-icon" {...statusIconProps} />
    )
}

/**
 * This function creates a sibling in the lower right corner if the respective status is set.
 * Available statuses are, 'AVAILABLE', 'BUSY' and 'NOT_AVAILABLE'.
 * If no status is not specified, only the child is returned.
 *
 * @example
 * <IconStatusWrapper className="someAwesomeClass">
 *     <VehicleIcon />
 * </IconStatusWrapper>
 *
 */
function IconStatusWrapper(props) {
    const { children } = props
    return (
        <div data-testid="icon-status-wrapper" className={cx('t3sel-icon-status-wrapper', props.className)}>
            {children}
            {renderStatusIcon(props)}
        </div>
    )
}

IconStatusWrapper.defaultProps = defaultProps
IconStatusWrapper.propTypes = propTypes

export { IconStatusWrapper }
